import type { LexicalNode } from 'lexical';

import { CodeHighlightNode, CodeNode } from '@lexical/code';
import { HashtagNode } from '@lexical/hashtag';
import { AutoLinkNode, LinkNode } from '@lexical/link';
import { ListItemNode, ListNode } from '@lexical/list';
import { MarkNode } from '@lexical/mark';
import { OverflowNode } from '@lexical/overflow';
import { HorizontalRuleNode } from '@lexical/react/LexicalHorizontalRuleNode';
import { HeadingNode, QuoteNode } from '@lexical/rich-text';
import { TableCellNode, TableNode, TableRowNode } from '@lexical/table';
import { Class } from 'utility-types';

import { EmojiNode } from './EmojiNode';
import { ImageNode } from './ImageNode';
import { KeywordNode } from './KeywordNode';
import { MentionNode } from './MentionNode';
import { PollNode } from './PollNode';
import { StickyNode } from './StickyNode';
import { TweetNode } from './TweetNode';
import { TypeaheadNode } from './TypeaheadNode';
import { YouTubeNode } from './YouTubeNode';

import { EquationNode } from './EquationNode';
import { LayoutContainerNode } from './LayoutContainerNode';
import { LayoutItemNode } from './LayoutItemNode';
import {PageBreakNode} from './PageBreakNode';

import {CollapsibleContainerNode} from '../nodes/CollapsibleContainerNode';
import {CollapsibleContentNode} from '../nodes/CollapsibleContentNode';
import {CollapsibleTitleNode} from '../nodes/CollapsibleTitleNode';

import { BoxNode } from './BoxNode';
import { BoxContentNode } from './BoxContentNode';

import { installTableNodePatches } from '../utils/tableWidthLexical';

// 표를 HTML 로 내보낼 때(인쇄·시험지·미리보기 — 내보내는 26곳이 모두 이 노드 목록을 쓴다) 편집기와 같은
// 폭 비율·정렬을 입히고, 저장된 표를 다시 읽을 때 정렬을 되살린다(Lexical 0.11 은 버린다).
// 모듈을 읽을 때마다 Lexical 원본 위에 다시 감싼다 — 몇 번 읽혀도 한 겹이고, 코드가 바뀌어 끼워지면 새 규칙이 걸린다.
installTableNodePatches();

const PlaygroundNodes: Array<Class<LexicalNode>> = [
  HeadingNode,
  ListNode,
  ListItemNode,
  QuoteNode,
  CodeNode,
  TableNode,
  TableCellNode,
  TableRowNode,
  HashtagNode,
  CodeHighlightNode,
  AutoLinkNode,
  LinkNode,
  OverflowNode,
  PollNode,
  StickyNode,
  ImageNode,
  MentionNode,
  EmojiNode,
  TypeaheadNode,
  KeywordNode,
  HorizontalRuleNode,
  TweetNode,
  YouTubeNode,
  MarkNode,
  EquationNode,
  LayoutContainerNode,
  LayoutItemNode,
  PageBreakNode,
  CollapsibleContainerNode,
  CollapsibleContentNode,
  CollapsibleTitleNode,
  BoxNode,
  BoxContentNode,
];

export default PlaygroundNodes;
